import React from "react";
import Default from "@ApplicationProcess/Default";

function ApplicationProcess( {settings} ) {
    return <Default settings={settings}/>;
}

export default ApplicationProcess;